import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonContent, IonHeader, IonFooter, IonCheckbox, IonText } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'

import { useHistory} from "react-router-dom";


function setFunction_initialSetup(event) {

    Preferences.set({
        key: 'initial_setup',
        //value: event,
        value: JSON.stringify({
            setup_id: event[0],
            details: event[1],
            status: event[2],
            dateCreated: event[3],
            lastModified: event[4],
        })

    })

}

function setFunction_tutorial(event) {


    alert("in SET FUNCTION TUTORIAL");
    alert(event);

    Preferences.set({
        key: 'selected_tutorial',
        //value: event,
        value: JSON.stringify({
            tutorial_id: event[0],
            tutorial_name: event[1],
            details: event[2],
            status: event[3],
            dateCreated: event[4],
            lastModified: event[5],
        })

    })

}

export function DeleteItemModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [itemID, setItemID] = useState(null); 

    let [searchResults, setSearchResults] = useState([]);

    let itemNameRef = useRef();

    let history = useHistory();



    function searchList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);

    }


    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {
        //setSearchResults([]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '33_searchDeleteItem',
                user: acctID,
                xSearchData: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_itemId: cols[0],
                                            db_itemName: cols[1],
                                            db_itemDescription: cols[2],
                                            db_vendorPartNumber: cols[3],
                                            db_vendorName: cols[4],
                                            db_vendorPhoneNumber: cols[5],
                                            db_vendorAddress: cols[6],
                                            db_vendorCity: cols[7],
                                            db_vendorCountry: cols[8],
                                            db_costPerUnit: cols[9],
                                            db_qtyInStock: cols[10],
                                            db_qtyInUse: cols[101],
                                            db_dateCreated: cols[12],
                                            db_attachment: cols[13],
                                        })
                                    });
                                
                                    //document.getElementById('deleteItemGrid').style.display = 'inline-block';
                            }
                    })
    }

    function deleteItem()
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '33_deleteItem',
                user: acctID,
                xInventoryItemID: itemID,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            handleInput(['deleted_item', ""]);

        })
        .catch(error => {
            console.error(error);
        })

    }

let timeout;

function handleInput(event) {

    setSearchResults([]);

    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchList(event), 2000); // Set a new timeout

}

    function closeModalHandler() {

        props.closeModal(false);
    }

    //alert("Create Inventory Item");

function setItemIDHandler(event) {

    if (itemID === event) {
        // Deselect if the same item is clicked
        setItemID(null);
    } else {
        // Select the new item
        setItemID(event);
    }
};

useEffect(() => {

    searchList(['initial_search', ""]);

}, [])


    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal id='deleteInventoryItemModal' isOpen={ props.openModal}>
                    <IonHeader style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonText>DELETE ITEM</IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                <IonContent className='grid_content'>

                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <label for='searchInventoryItem_deleteItem'>Search Item For Deletion </label>
                                        <input type='text' id='searchInventoryProduct_DeleteProduct' ref={ itemNameRef } placeholder='Search Inventory Items To Delete' onInput={() => handleInput(['delete_stock_item', itemNameRef.current.value])} list='searchInventoryItem_deleteItemList' autocomplete='off' required></input>
                                        <datalist id='searchInventoryItem_deleteItemList'>
                                            {searchResults.map((result) => (
                                                <option key={result.db_itemId} value={result.db_itemName}></option>
                                            ))}
                                        </datalist>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                            <div id='deleteItemGrid' style={{display: 'inline-block'}}>
                            <IonGrid >
                            <IonRow >
                                        <IonCol >Item ID</IonCol>
                                        <IonCol >Item Name</IonCol>
                                        <IonCol >Qty InStock</IonCol>
                                        <IonCol >Qty InUse</IonCol>
                                        <IonCol >Action</IonCol>
                                </IonRow>
                                {searchResults.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.db_itemId}</IonCol>
                                            <IonCol >{detailData.db_itemName}</IonCol>
                                            <IonCol >{detailData.db_qtyInStock}</IonCol>
                                            <IonCol >{detailData.db_qtyInUse}</IonCol>
                                            <IonCol >
                                                <IonCheckbox checked={itemID == detailData.db_itemId} disabled={itemID != null && itemID != detailData.db_itemId} placeholder='Enter Qty' onIonChange={() => setItemIDHandler(detailData.db_itemId)}></IonCheckbox>              
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            </div>

                    </IonContent>
                <IonFooter className='appFooter'>
                    <IonGrid>
                            <IonRow>
                                <IonCol size="6">
                                {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '4' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false)
                                ?<IonButton className='modal_footer_button_left flash-tutorial' onClick={() => deleteItem()}> Confirm </IonButton> 
                                :<IonButton className='modal_footer_button_left' onClick={() => deleteItem()}> Confirm </IonButton>}
                                </IonCol>
                                <IonCol size="6">
                                    <IonButton className='modal_footer_button_right' onClick={() => props.closeModal(false)}>Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                </IonFooter>
                </IonModal>) : null
                }
            </React.Fragment>

    )
}